import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '../../services/inventory.service';
import { PrintService } from '../../services/print.service';
import { DashboardService } from '../../services/dashboard.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';


@Component({
	selector: 'app-negative-items',
	templateUrl: './negative-items.component.html',
	styleUrls: ['./negative-items.component.scss']
})
export class NegativeItemsComponent {
	negativeItems: any = [];
	color = 'blue';
	filename = 'negative_items';
	@ViewChild('print_table') printtable: ElementRef;
	subscritionsactive: any = false;
	exporting = false;
	locations: any = [];
	selectedLoc: any = '';
	filteredNegativeItems: any = [];
	constructor(
		private printService: PrintService,
		private dashboardService: DashboardService,
		private globalSearchService: GlobalSearchService,
		private router: Router,
		private location: Location,
		private route: ActivatedRoute
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.globalSearchService.locations.subscribe(locs => {
			this.locations = locs || [];
			this.loadData();
		});
	}
	
	
	applyLocationFilter(loccode: string): void {
	  if (!loccode) {
			this.filteredNegativeItems = this.negativeItems;
			return;
	  }
	
	  const result = [];
	
	  for (const item of this.negativeItems) {
			const matching = item.locations.filter(loc => loc.loccode === loccode);
			if (matching.length > 0) {
		  result.push({ ...item, locations: matching });
			}
	  }
	
	  this.filteredNegativeItems = result;
	}
	
	
	loadData(): void {
		if(this.subscritionsactive) {
			this.subscritionsactive.unsubscribe();
		}
		this.subscritionsactive= this.dashboardService.getNegative().subscribe(async (results: any) => {
			
			this.negativeItems = (results.data) ? results.data : [];
			this.filteredNegativeItems = this.negativeItems;
		});
	}

	viewItem(item: any): void {
		this.router.navigate(['/inventory/view/' + item.stockid]);
	}

	back(): void {
		this.location.back();
	}

	exportPdf() {
		const encoded: string = btoa(this.printtable.nativeElement.innerHTML);
		const now = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Negative Items',
			subtitle: `Created: ${now.toLocaleDateString()} ${now.toLocaleTimeString()}`
		};
	
		this.exporting = true;
		this.printService.pdf(data).subscribe((result: any) => {
			this.exporting = false;
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}
	
	exportXls() {
		const encoded: string = btoa(this.printtable.nativeElement.innerHTML);
		const now = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Negative Items',
			subtitle: `Created: ${now.toLocaleDateString()} ${now.toLocaleTimeString()}`
		};
	
		this.exporting = true;
		this.printService.xls(data).subscribe((result: any) => {
			this.exporting = false;
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}


	ngOnDestroy(): void {
	  if (this.subscritionsactive) {
			this.subscritionsactive.unsubscribe();
	  }
	}
}
